
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from "redux";
import {
  ScheduleComponent,
  ViewsDirective, 
  ViewDirective,
  Day,
  Agenda,
  Inject,
  Resize,
  DragAndDrop,
  ResourcesDirective,
  ResourceDirective
} from '@syncfusion/ej2-react-schedule';
import { setCulture, L10n, loadCldr } from '@syncfusion/ej2-base';
import orderBy from "lodash/orderBy";
import currencies from '@syncfusion/ej2-cldr-data/main/es/currencies.json';
import gregorian from '@syncfusion/ej2-cldr-data/main/es/ca-gregorian.json';
import numbers from '@syncfusion/ej2-cldr-data/main/es/numbers.json';
import timeZoneNames from '@syncfusion/ej2-cldr-data/main/es/timeZoneNames.json';
import numberingSystems from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';
import weekData from '@syncfusion/ej2-cldr-data/supplemental/weekData.json';// To load the culture based first day of week
import {getCalendars} from "../../../calendar/components/sidebar/sidebar.actions";
//import './schedule-component.css';
import { DataManager } from '@syncfusion/ej2-data';
import { getEventListByRange } from '../../api/calendar-api';
import moment from 'moment';
import { dateTimeDiff, getDateTimeInHHMM } from "../../../utils/utils";
import i18n from 'i18next';
import Dot from '../../../components/dot/dot';

export class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadCalendar: false
    };
    this.onCalendarChange = this.onCalendarChange.bind(this);
    this.onActionComplete = this.onActionComplete.bind(this);
    this.dataManger = new DataManager();
    this.resourceCalendarData = [];
    this.selectedCalendarId = null;
    this.lastLoadedRangeKey = null;
    this.setGlobalization();
  }

  componentDidMount() {
    this.props.getCalendars(
      this.props.lexon.userId,
      this.props.login.formValues.user,
      this.props.lexon.lexonToken
    );
    this.setState({
      loadCalendar: true
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.calendarsResult.calendars !== this.props.calendarsResult.calendars) {
      if (this.state.loadCalendar) {
        const calendarsResult = orderBy(this.props.calendarsResult.calendars, "primary");
        let selected = calendarsResult.find(x => x.checked || x.selected);
        if (!selected) {
          selected = calendarsResult[0];
        }
        this.loadCalendarEvents(selected.id, true);
        this.setState({
          loadCalendar: false
        });
      }
    }
  }

  getVisibleDateRange() {
    const fallbackDate = this.scheduleObj?.selectedDate instanceof Date && !isNaN(this.scheduleObj.selectedDate.getTime())
      ? this.scheduleObj.selectedDate
      : new Date();
    const dayStart = new Date(fallbackDate);
    dayStart.setHours(0, 0, 0, 0);
    const dayEnd = new Date(fallbackDate);
    dayEnd.setHours(23, 59, 59, 999);

    if (!this.scheduleObj) {
      return {
        view: 'Day',
        start: dayStart,
        end: dayEnd
      };
    }

    const currentView = this.scheduleObj.currentView || 'Day';
    const viewDates = typeof this.scheduleObj.getCurrentViewDates === 'function'
      ? this.scheduleObj.getCurrentViewDates()
      : [];

    if (viewDates.length > 0) {
      const rangeStart = new Date(viewDates[0]);
      const rangeEnd = new Date(viewDates[viewDates.length - 1]);
      rangeStart.setHours(0, 0, 0, 0);
      rangeEnd.setHours(23, 59, 59, 999);
      return {
        view: currentView,
        start: rangeStart,
        end: rangeEnd
      };
    }

    return {
      view: currentView,
      start: dayStart,
      end: dayEnd
    };
  }

  loadCalendarEvents(calendar, forceReload = false) {
    this.selectedCalendarId = calendar;
    const { view, start, end } = this.getVisibleDateRange();
    const loadKey = `${calendar}|${view}|${start.toISOString()}|${end.toISOString()}`;

    if (!forceReload && this.lastLoadedRangeKey === loadKey) {
      return;
    }

    this.lastLoadedRangeKey = loadKey;

    getEventListByRange(
      calendar,
      this.props.lexon.userId,
      this.props.login.formValues.user,
      this.props.lexon.lexonToken,
      start,
      end
    )
      .then(result => {
        this.dataManger = result.result;
        this.onDataBinding(this.dataManger);
        this.scheduleObj.refreshEvents();
      })
      .catch(error => {
        this.lastLoadedRangeKey = null;
        console.error('error ->', error);
      });
  }

  onActionComplete(args) {
    if (!this.selectedCalendarId) {
      return;
    }

    if (args.requestType === 'dateNavigate' || args.requestType === 'viewNavigate') {
      this.loadCalendarEvents(this.selectedCalendarId);
    }
  }

  async setGlobalization() {
    if (window.navigator.language.includes("es-")
            || (window.navigator.language === "es")
            || (window.navigator.language === "ca")
            || (window.navigator.language === "ga")
            || (window.navigator.language === "eu")) {
      loadCldr(currencies, numberingSystems, gregorian, numbers, timeZoneNames, weekData);
      const data = await import('../../../calendar/syncfusion-resources/calendar-es.json');
      setCulture('es');
      L10n.load(data);
    }
  }

  onDataBinding(e) {
    const calendarId = "primary";
    const items = this.dataManger.items;
    const scheduleData = [];
    if (items.length > 0) {
      for (let i = 0; i < items.length; i++) {
        const event = items[i];
        if (event.status === 'cancelled') {
          const dateStartTime = new Date(event.originalStartTime.dateTime);
          const dateString = `${moment(dateStartTime).seconds(0).toISOString().split('.')[0]}Z`;
          const ExcRecurenceDate = dateString.replace(/[:.-]/g, "");
          let ParentscheduleException = "";
          let coma = "";
          if (this.scheduleData.find(x => x.Id == event.recurringEventId).RecurrenceException != undefined) {
            ParentscheduleException = this.scheduleData.find(x => x.Id == event.recurringEventId).RecurrenceException;
            coma = ",";
          }
          this.scheduleData.find(x => x.Id == event.recurringEventId).RecurrenceException = ParentscheduleException + coma + ExcRecurenceDate;
          continue;
        }
        let when = event.start.dateTime;
        let start = event.start.dateTime;
        let end = event.end.dateTime;
        if (!when) {
          when = event.start.date;
          start = event.start.date;
          end = event.end.date;
        }
        let recurrenceRule;
        if (event.recurrence != undefined) {
          recurrenceRule = event.recurrence[0].replace('RRULE:', '');
        }
        let lexonClassification = null;
        if (event.extendedProperties != undefined) {
          lexonClassification =
            event.extendedProperties?.private?.lexonClassification;
        }

        try {
          scheduleData.push({
            Id: event.id,
            CalendarId: calendarId,
            Subject: event.summary,
            Location: event.location,
            Description: event.description,
            StartTime: new Date(start),
            EndTime: new Date(end),
            IsAllDay: !event.start.dateTime,
            RecurrenceRule: recurrenceRule,
            ImageName: "icon-lefebvre-bl",
            LexonClassification: lexonClassification,
            EventType: {
              color: event?.color,
            }
          });
        } catch (error) {
          console.error(error);
        }
      }
    }
    e.result = scheduleData;
  }

  text_truncate(str, length, ending) {
    if (length == null) {
      length = 10;
    }
    if (ending == null) {
      ending = "...";
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending;
    } else {
      return str;
    }
  }


  eventTemplate(props) {
    const { 
      StartTime: startTime,
      LexonClassification: lexonClassification,
      Subject: subject,
      Location: location,
      ImageName: imageName,
      EventType: eventType,
      IsAllDay: isAllDay,
    } = props;

    const subjectStr = subject ?? i18n.t("schedule.notitle");

    return (
      <div 
        style={{ width: '98%', cursor: 'pointer', height: '100%', color: 'var(--white)' }}
        data-toggle="tooltip"
        data-placement="top"
        title={props.Subject}
      >
        <div className="image">
          <div className="eventicon d-flex ml-1 align-items-center">
            {lexonClassification && (
              <img
                className="mr-2"
                width="16"
                height="16"
                src={`/assets/images/${imageName}.png`}
                alt="event-data"
              />
            )}
            {!isAllDay && (
              <div>
                  {moment(startTime).format("HH:mm")}
              </div>
            )}
            <div style={{ flex: '50%'}} className="text-truncate-calendar ml-1">
              {subjectStr}
            </div>
            <p className="ml-2">{location}</p>
            {
              eventType?.color && (
                <div className="event-card-data-dot">
                    <Dot color={eventType?.color} size={12} />
                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }

  getTimeDiffString(start, end) {
    const { hours, minutes } = dateTimeDiff(start, end);
    return hours > 0 ? `${hours}h ${minutes}min` : `${minutes}min`;
  }

  eventTemplateAgendaView(props) {
    const { 
      StartTime: startTime,
      EndTime: endTime,
      LexonClassification: lexonClassification,
      IsAllDay: isAllDay,
      Subject: subject,
      EventType: eventType
    } = props;
    const subjectStr = subject ?? i18n.t("schedule.notitle");
    const eventDuration = this.getTimeDiffString(startTime, endTime);
    return (
      <div>
        <div className="event-card-data">
          {isAllDay ? (
            <div className="d-flex align-items-center">
              {lexonClassification && (
                <img
                  className="event-lefebvre-img"
                  width="16"
                  height="16"
                  src="assets/images/lefebvre.png"
                  alt="event-data"
                />
              )}
              <span className="event-card-data-allday">{i18n.t('calendar.allDay')}</span>
              <span className="event-card-data-title ml-3">{subjectStr}</span>
            </div>
          ) : (
            <>
              <div className="d-flex align-items-center">
                {
                  lexonClassification && (
                    <img
                      className="event-lefebvre-img"
                      width="16"
                      height="16"
                      src="assets/images/lefebvre.png"
                      alt="event-data"
                    />
                  )
                }
                <span className="event-card-data-time">{getDateTimeInHHMM(startTime)}</span>
                <span className="event-card-data-title">{subjectStr}</span>
              </div>
              <div className="d-flex align-items-center">
                <div className="event-card-data-duration">
                  {eventDuration}
                </div>
                {
                  eventType?.color && (
                      <div className="event-card-data-dot">
                        <Dot color={eventType?.color} size={12} />
                      </div>
                    )
                }
                 {props?.RecurrenceRule && (
                  <span className="event-card-data-recurrence" />
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  onCalendarChange(args) {
    const value = parseInt(args.event.target.getAttribute('value'), 10);
    if (args.checked) {
      this.scheduleObj.addResource(this.dataManger, 'items', value - 1);
    } else {
      this.scheduleObj.removeResource(value, 'Calendars');
    }
  }

  onPopupOpen(args) {
    args.cancel = true;
    const lexon = this.props.lexon.lexonToken ? this.props.lexon.lexonToken : this.props.lexon.user;
    if (this.props.lexon.lexonToken) {
      window.open(`calendar/access/${lexon}/?prov=IM0`, "_blank");
    } else if (this.props.lexon.user) {
      window.open(`calendar/user/${lexon}`, "_blank");
    } else {
      window.open("calendar", "_blank");
    }
  }

  doubleOpen(args) {
    args.cancel = true;
    const lexon = this.props.lexon.lexonToken ? this.props.lexon.lexonToken : this.props.lexon.user;
    if (this.props.lexon.lexonToken) {
      window.open(`calendar/access/${lexon}/?prov=IM0`, "_blank");
    } else if (this.props.lexon.user) {
      window.open(`calendar/user/${lexon}`, "_blank");
    } else {
      window.open("calendar", "_blank");
    }
  }

  render() {
    return (
      <div className='schedule-control-section-card'>
        <div className='control-section h-100'>
          <div className='control-wrapper h-100'>
            <ScheduleComponent 
              ref={schedule => this.scheduleObj = schedule}
              width='100%'
              height="100%"
              currentView="Day"
              firstDayOfWeek={1}
              readonly={false}
              popupOpen={this.onPopupOpen.bind(this)}
              dateFormat="dd/M/yyyy"
              actionComplete={this.onActionComplete}
              cellDoubleClick={this.doubleOpen.bind(this)}                            
              eventSettings={{ dataSource: this.dataManger }} 
              dataBinding={this.onDataBinding.bind(this)}>
              <ViewsDirective>
                  <ViewDirective 
                      option='Day'
                      eventTemplate={this.eventTemplate.bind(this)}
                      dateFormat="dd MMMM yyyy"
                  />                               
                  <ViewDirective 
                      option='Agenda' 
                      eventTemplate={this.eventTemplateAgendaView.bind(this)}
                  />
              </ViewsDirective>
              <Inject services={[Day, Agenda, Resize, DragAndDrop]} />
              <ResourcesDirective>
                  <ResourceDirective 
                      field='CalendarId' 
                      title='My Calendars' 
                      name='Calendars' 
                      allowMultiple={false} 
                      dataSource={this.resourceCalendarData} 
                      textField='summary' 
                      idField='id' 
                      colorField='backgroundColor'
                  >
                  </ResourceDirective>
              </ResourcesDirective>
            </ScheduleComponent>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  lexon: state.lexon,
  login: state.login,
  calendarsResult: state.calendarsResult
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      getCalendars
    },
    dispatch
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Card);
